import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const Footer = () => {
    const currentYear = new Date().getFullYear();
  return (
    <motion.footer
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8 }}
      style={{
       
        bottom: 0,
        left: 0,
        width: '100%',
        background: '#319795',
        color: '#fff',
        textAlign: 'center',
        padding: '10px 0',
       
      }}
    >
      <Text>{currentYear} © All rights reserved by <a target="_blank" href='https://www.linkedin.com/in/moezdev'>Moez Ahsan</a></Text>
    </motion.footer>
  );
};

export default Footer;
